import React, { memo } from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import BillPaymentHalfCardContent from "./BillPaymentHalfCardContent";
import { IBillPaymentHalfCardProps } from "./types";

const BillPaymentHalfCard = memo(
    ({ show, onClose, onCtaClick, billPaymentCardData }: IBillPaymentHalfCardProps) => {
        return (
            <HalfCard
                isOpen={show}
                hasCustomPadding={true}
                hideCloseIcon={false}
                closeOnOverlayClick={true}
                onClose={onClose}
            >
                <BillPaymentHalfCardContent
                    onCtaClick={onCtaClick}
                    billPaymentCardData={billPaymentCardData}
                />
            </HalfCard>
        );
    }
);

BillPaymentHalfCard.displayName = "BillPaymentHalfCard";

export default BillPaymentHalfCard;
